import { render } from "./AdvisorThingsRequiringAttention.vue?vue&type=template&id=988355d4&scoped=true"
import script from "./AdvisorThingsRequiringAttention.vue?vue&type=script&lang=js"
export * from "./AdvisorThingsRequiringAttention.vue?vue&type=script&lang=js"

import "./AdvisorThingsRequiringAttention.vue?vue&type=style&index=0&id=988355d4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-988355d4"]])

export default __exports__